import { Controller } from '@hotwired/stimulus';
import { SearchesMixin } from '../../../mixins/searches_mixin';

export default class extends Controller {
  static targets = [
    'searchWrapper',
    'searchInput',
    'userIdInput',
    'selectedUser',
    'selectedAuthor',
    'selectedAuthorId',
    'submitButton',
  ];

  initialize() {
    SearchesMixin(this, 'User');

    this.initializeSearch(
      {
        selector: this.searchWrapperTarget,
        query: {},
        noResultsMessage: 'Nie znaleziono pasujących wyników',
      },
      this.searchCallbacks(),
      this.customResultsTemplate(),
    );
  }

  connect() {
    this.searchInputTarget.addEventListener('input', this.handleInputChange);
  }

  disconnect() {
    this.searchInputTarget.removeEventListener('input', this.handleInputChange);
  }

  handleInputChange = () => {
    this.userIdInputTarget.value = '';
    this.selectedUserTarget.classList.add('hidden');
    this.submitButtonTarget.disabled = true;
  };

  searchCallbacks() {
    return {
      onSelect: (result) => {
        this.userIdInputTarget.value = result.id;
        this.selectedAuthorTarget.textContent = result.title;
        this.selectedAuthorIdTarget.textContent = result.id;
        this.selectedUserTarget.classList.remove('hidden');
        this.submitButtonTarget.disabled = false;

        // prevent reappearing of the search results
        setTimeout(() => {
          $(this.searchWrapperTarget).search('set value', result.title);
          $(this.searchWrapperTarget).search('hide results');
          this.searchInputTarget.blur();
        }, 100);

        // prevent default action (closing search results and selecting value).
        return false;
      },
    };
  }
}
